module.exports = __webpack_public_path__ + "img/checked.62146b87.svg";